export default "__VITE_ASSET__Bp5G0Ld8__"